<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { CLIENT_TYPE_WEB, clientType } from '@/apis/api'
import { ElDialog, ElMessage } from 'element-plus'
import { getWechatTempQr, type QrTempBindCommand } from '@/composables/wechat/wechat'
import { onMounted, type Ref } from 'vue'
import { handleErr } from '@/composables/exception/handler'
import type { CommonResponse } from '@/apis/api'
import { CODE_OK } from '@/apis/code'
import { renderMessage } from '@/utils/util'
import QRCode from 'qrcode'

const { t } = useI18n()

const visible = defineModel({
  type: Boolean,
  default: false
})
let innerWidth = ref(0)
if (typeof window !== 'undefined') {
  innerWidth.value = window.innerWidth
}

// 根据屏幕宽度判断是否可展开
const isExpandable = computed(() => {
  return innerWidth.value <= 768 // 移动端可展开，PC端不可展开
})
const props = defineProps<{
  tipsText?: string
  content: string
  url: string
  actionTxt: string
}>()
const qrUrl = ref('')
const qrImgSrc = ref('')
onMounted(() => {
  console.log('开始请求')
  getData()
})
const getData = async () => {
  const command: QrTempBindCommand = {
    content: props.content,
    url: props.url,
    actionTxt: props.actionTxt,
    expireSeconds: 86400
  }
  const { data, error, statusCode } = await getWechatTempQr(command)
  if (error.value) {
    handleErr(data, error, statusCode)
  } else {
    const resData = data as Ref<CommonResponse<any>>
    if (resData.value.code === CODE_OK) {
      qrUrl.value = resData.value.data.qrUrl
      try {
        qrImgSrc.value = await QRCode.toDataURL(qrUrl.value, { width: 150, margin: 0 })
      } catch (err) {
        console.error(err)
      }
      console.log('!!!!resData!!!!', resData)
    } else {
      ElMessage({
        message: renderMessage(resData.value.message),
        type: 'warning'
      })
    }
  }
}

const isPc = computed(() => clientType.value == CLIENT_TYPE_WEB)
</script>
<template>
  <teleport to="body">
    <RAction
      v-model="visible"
      :expandable="isExpandable"
      @close="visible = false"
      :zIndex="10000"
      :fromBottom="true"
      :mask="false"
      :backdropHide="true">
      <div bg-base border-1 border-grey overflow-hidden w-full md:max-w-150 rounded-t-2 relative>
        <div grow text-xl text-center mt-6>{{ isPc ? t('obituary.qrcode_tip1_pc') : t('obituary.qrcode_tip1') }}</div>
        <button
          absolute
          right-3
          top-2.5
          p-1
          cursor-pointer
          bg-transparent
          style="pointer-events: auto"
          @click="visible = false">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
            <path
              fill="currentColor"
              d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z" />
          </svg>
        </button>
        <div flex="~ col" items-center w-full justify-center p-2 pt-1 pb-8>
          <div text-second my-4>
            {{ props.tipsText ? props.tipsText : isPc ? t('obituary.qrcode_tip2_pc') : t('obituary.qrcode_tip2') }}
          </div>
          <!-- <img :src="qrUrl" mt-4 w-48 /> -->
          <img :src="qrImgSrc" class="w-[150px] h-[150px]" />
        </div>
      </div>
    </RAction>
  </teleport>
</template>
<style lang="scss" scoped></style>
